import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import './ProductList.css';
import { useSelector } from "react-redux";

export const ProductList = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [loading , setLoading] = useState(false);
  const theme = useSelector((state)=>state.theme);
 const navigate = useNavigate();

 function navigateHome() {
  navigate('/' );
}

function navigateBack() {
  navigate(-1,{ replace: true });
}

function navigateNext() {
  navigate(+1);
}
// .............................................................................
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://fakestoreapi.com/products");
      setData(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      {loading?(
        <div className="loaderDiv">
        <span class="loader"></span>
        <span class="loader"></span>
        <span class="loader"></span>
        <span class="loader"></span>
        <span class="loader"></span>
        <span class="loader"></span>
        </div>):(
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto auto auto auto auto",
            textAlign: "center",
            backgroundColor: theme === "light"? "white":"#44444C",
          }}
        >
          {data?.map((product) => {
            return (
              <Link to={`/ProductDetail/${product?.id}`} key={product.id}>
                <div
                  className="main-container-2-item"
                  style={{
                    boxShadow:
                      " 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19",
                    margin: "10px",
                    padding: "15px",
                    backgroundColor: theme === "light"? "white":"white",
                  }}
                >
                  <img
                    src={product.image ? product.image : ''}
                    alt={product.title}
                    width={"200px"}
                    height={"250px"}
                    style={{ marginTop: "15px" }}
                  />
                  <h4>{product.title.slice(0, 25)}</h4>
                  <p style={{ color: "black" }}>
                    {" "}
                    <b> Rs.{product?.price}</b>{" "}
                    <del style={{ color: "#555" }}>Rs.3499</del>{" "}
                    <small style={{ color: "red" }}>(Rs 2280 OFF)</small>
                  </p>
                  <p> Rating {product.rating.rate}</p>
                </div>
              </Link>
            );
          })}
        </div>)}

        {/* //Navigate button */}
        <div className='navigate-Btn'  style={{
            backgroundColor: theme === "light"? "white":"#44444C",
          }}>
      <button className='navigate-Btn back' onClick={navigateBack}>Back</button>
      <button className='navigate-Btn home' onClick={navigateHome}> Home Page</button>
      <button className='navigate-Btn next' onClick={navigateNext}> Next</button>
    </div>
    </>
  );
};
